class StoreLocator extends HTMLElement {
  constructor() {
    super();
    this.sidebar = this.querySelector('.stores__sidebar');
    this.overlay = this.querySelector('.stores__overlay');
    this.toast = this.querySelector('.stores__toast');
    this.sidebarOpenerBtn = this.querySelector('.stores__sidebar-opener-btn');
    this.sidebarCloseBtn = this.querySelector('.stores__close-btn');
    this.countryItems = this.querySelectorAll('.country-item');
    this.storeCards = this.querySelectorAll('.store-card');
    this.storeCount = this.querySelector('.store-count');
    this.countrySelect = this.querySelector('.country-select')
    const desktopMedia = window.matchMedia('(min-width: 768px)');
    this.shareButtons = this.querySelectorAll('.store-card__link--share');
    this.toastTimeout = null;

    if (this.sidebarOpenerBtn && this.sidebar) {
      this.sidebarOpenerBtn.addEventListener('click', () => this.openSidebar());
    }

    if (this.sidebarCloseBtn) {
      this.sidebarCloseBtn.addEventListener('click', () => this.closeSidebar());
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.closeSidebar());
    }

    this.countryItems.forEach(country => {
      country.addEventListener('click', this.findStores.bind(this))
    })

    this.countrySelect.addEventListener('change', this.onCountryChange.bind(this));

    document.addEventListener('DOMContentLoaded', this.checkUrlOnLoad.bind(this))

    desktopMedia.addEventListener('change', (e) => {
      if (e.matches) {
        this.closeSidebar();
      }
    });

    this.shareButtons.forEach(btn => {
      btn.addEventListener('click', this.handleShare.bind(this));
    });
  }

  openSidebar() {
    this.sidebar.classList.add('stores__sidebar--open');
    if (this.overlay) this.overlay.classList.add('stores__overlay--active');
    document.body.style.overflow = 'hidden';
  }

  closeSidebar() {
    this.sidebar.classList.remove('stores__sidebar--open');
    if (this.overlay) this.overlay.classList.remove('stores__overlay--active');
    document.body.style.overflow = '';
  }

  findStores(e) {
    const target = e.target
    const targetCountryHandle = target.dataset.countryHandle
    const targetCountryName = target.dataset.countryName
    let foundStores = 0

    // 1. Active class
    this.countryItems.forEach(el => el.classList.remove('active'))
    target.classList.add('active')

    // 2. Show related cards
    this.storeCards.forEach(card => {
      const cardCountryHandle = card.dataset.countryHandle

      card.classList.add('hidden')

      if (targetCountryHandle === 'all') {
        card.classList.remove('hidden')
        foundStores = this.storeCards.length
      } else {
        if (cardCountryHandle === targetCountryHandle) {
          card.classList.remove('hidden')
          foundStores += 1
        }
      }
    })

    // 3. Update store count
    if (targetCountryHandle === 'all') {
      this.storeCount.textContent = `${foundStores} Stores`;
    } else if (foundStores === 1) {
      this.storeCount.textContent = `${foundStores} Store found in ${targetCountryName}`;
    } else {
      this.storeCount.textContent = `${foundStores} Stores found in ${targetCountryName}`;
    }

    // 4. Update URL
    const url = new URL(window.location.href)
    if (targetCountryHandle === 'all') {
      url.searchParams.delete('country')
    } else {
      url.searchParams.set('country', targetCountryHandle)
    }
    window.history.replaceState({}, '', url.toString())

    // 5. Close the sidebar
    if (this.sidebar.classList.contains('stores__sidebar--open')) {
      this.closeSidebar()
    }
  }

  onCountryChange(e) {
    const selectedOption = e.target.selectedOptions[0];
    const countryHandle = selectedOption.dataset.countryHandle;
    const countryItem = document.querySelector(`.country-item[data-country-handle="${countryHandle}"]`);

    if (!countryItem) return;
    countryItem.click()
  }

  checkUrlOnLoad() {
    const countryHandle = this.getCountryFromUrl();
    if (countryHandle) {
      const countryItem = document.querySelector(`.country-item[data-country-handle="${countryHandle}"]`);
      countryItem.click()
    }
  }

  getCountryFromUrl() {
    return new URLSearchParams(window.location.search).get('country');
  }

  handleShare(e) {
    const btn = e.currentTarget;
    const shareUrl = btn.dataset.shareUrl

    navigator.clipboard.writeText(shareUrl.toString())
      .then(() => {
        this.showToast();
      })
      .catch(error => {
        console.error('Could not copy text: ', error);
      });
  }

  showToast() {
    if (!this.toast) return;

    if (this.toastTimeout) {
      clearTimeout(this.toastTimeout);
    }

    this.toast.classList.add('stores__toast--active');

    this.toastTimeout = setTimeout(() => {
      this.toast.classList.remove('stores__toast--active');
    }, 1000);
  }
}

if (!customElements.get('store-locator')) {
  customElements.define('store-locator', StoreLocator);
}